var React = require('react');

function PlusWhiteIconInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.5 12H19.5","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12.5 5V19","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

PlusWhiteIconInline.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = PlusWhiteIconInline;

PlusWhiteIconInline.default = PlusWhiteIconInline;
